<div mat-dialog-content id="certificate-modal" *ngIf="data.isCertificate">
    <button mat-raised-button class="close-button" (click)="onClose()">
        <mat-icon>close</mat-icon>
    </button>
    <p class="center">{{data.certificate}}</p>
</div>

